import React from 'react';

import { Box } from '@mui/material';

import LoadingStepIcon from './LoadingStepIcon';
import LoadingStepDelimiter from './LoadingStepDelimiter';

import { ILoadingProgressTutorial } from './interfaces';

import { useStyles } from './styles';
import Button from '@mui/material/Button';
import { useModalStyles } from '@core/myta/hooks/modalStyles';
import { useTranslation } from 'react-i18next';

const LoadingProgressTutorial = ({
  secondStepLoading,
  secondStepCompleted,
  thirdStepLoading,
  thirdStepCompleted,
  forthStepLoading,
  forthStepCompleted,
  showTeleportButton,
  handleTeleportButtonClick,
}: ILoadingProgressTutorial) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const modalClasses = useModalStyles();

  const primaryButtonSx = {
    ...modalClasses.button,
    ...modalClasses.buttonPrimary,
    width: 'auto'
  };

  return (
    <Box>
      <Box sx={classes.root}>
        <LoadingStepIcon loading={false} completed={true} />
        <LoadingStepDelimiter isCompleted />
        <LoadingStepIcon
          loading={secondStepLoading}
          completed={secondStepCompleted}
          step={2}
        />
        <LoadingStepDelimiter isCompleted={secondStepCompleted} />
        <LoadingStepIcon
          loading={thirdStepLoading}
          completed={thirdStepCompleted}
          step={3}
        />
        <LoadingStepDelimiter isCompleted={thirdStepCompleted} />
        <LoadingStepIcon
          loading={forthStepLoading}
          completed={forthStepCompleted}
          step={4}
        />
      </Box>
      {showTeleportButton && handleTeleportButtonClick ? (
        <Box sx={classes.teleportToWorld}>
          <Button
            sx={primaryButtonSx}
            variant="contained"
            size="large"
            onClick={() => handleTeleportButtonClick()}
          >
            {translate('playScreen.play')}
          </Button>
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
};

export default LoadingProgressTutorial;
